import * as React from 'react';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIDataModel } from '../../../uicomponent';
import { UIComponentViewImpl } from '../../../uicomponentview';
import { SearchBoxToneOptionComponentHandler, SearchBoxToneOptionComponentProps, SearchBoxToneOptionComponentState } from './searchboxtoneoptioncomponent';
import { SearchBoxToneOptionCSSStyle } from './searchboxtoneoptioncss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import './searchboxtoneoption-style.css';
import { CheckboxWithTextComponent } from '../../../checkboxwithtext/checkboxwithtextcomponent';
import { SearchBoxRadioCSSStyleImpl } from './searchboxradiocss';
import { MobileSearchBoxRadioCSSStyleImpl } from './mobilesearchboxradiocss';

export class SearchBoxToneOptionViewImpl extends UIComponentViewImpl<UIDataModel>  
{
    private searchInput: HTMLInputElement | null;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        // this.webCssStyle = new  SearchDropDownRowCSSStyleImpl(context);
        // this.mobileCssStyle = new MobileSearchDropDownRowCSSStyleImpl(context);
        // this.listViewModel = new SearchDropDownRowViewModelImpl(false, context, this);
        // this.listViewModel.setListDatas(optionsList);
    }
   

    bindHandlers()
    {
        this.onSearchBoxClick = this.onSearchBoxClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.clearData = this.clearData.bind(this);
        this.showOption = this.showOption.bind(this);
        this.hideOption = this.hideOption.bind(this);

    }

    draw(props: SearchBoxToneOptionComponentProps, state: SearchBoxToneOptionComponentState, cssStyle: SearchBoxToneOptionCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

       return (
           <>
             <div id="search-web-wrapper">
                 {
                     this.getWebView(props, state, cssStyle)
                 }
             </div>
             <div id="search-mobile-wrapper">
                 {
                     this.getMobileView(props, state, cssStyle)
                 }
             </div>
            </>
       );
    }


    getWebView(props: SearchBoxToneOptionComponentProps, state: SearchBoxToneOptionComponentState, cssStyle: SearchBoxToneOptionCSSStyle):JSX.Element
    {
        // this.listViewModel.setCssStyle(this.webCssStyle);
        console.log("getWebView :", state.isSearchOptionSelected , " id: " , state.defaultOptionId , " title:" , state.defaultOption);
        return(
                <>
                <form onSubmit={this.onSearchBoxClick}>

                     <div id="search-main-wrapper" style={cssStyle.getMainDivCSSStyle()}>
                
                <input placeholder={props.context.getResources().getString(Strings.type_to_search)} onChange={this.onChange} value={state.searchKey} ref={(item: any) => {this.searchInput = item;}} type="text" id='search' style={cssStyle.getSearchBoxInputDivCSSStyle()}/>
                <img  onClick={this.onSearchBoxClick} style={{marginTop:'18px',marginRight:"30px",marginLeft:'30px',cursor:'pointer'}} src={props.context.getResources().getImage('search.svg')} height="24px" width="24px" />

                
             </div> 
             {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                        <div style={{width:"100%",height:"40px",display:"flex",justifyContent:"center",marginTop:"10px"}}>
                                <CheckboxWithTextComponent onChange={(ischecked, title)=>this.onSelected(ischecked, this.getContext().getResources().getString(Strings.song),this.getContext().getResources().getString(Strings.Song))} isChecked={state.defaultOptionId === props.context.getResources().getString(Strings.song)} style={new SearchBoxRadioCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.Song)} context={props.context}/>
                                <CheckboxWithTextComponent onChange={(ischecked, title)=>this.onSelected(ischecked, this.getContext().getResources().getString(Strings.singer),this.getContext().getResources().getString(Strings.Singer))} isChecked={state.defaultOptionId === props.context.getResources().getString(Strings.singer)} style={new SearchBoxRadioCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.Singer)} context={props.context}/>
                                <CheckboxWithTextComponent onChange={(ischecked, title)=>this.onSelected(ischecked, this.getContext().getResources().getString(Strings.code),this.getContext().getResources().getString(Strings.Code))} isChecked={state.defaultOptionId === props.context.getResources().getString(Strings.code)} style={new SearchBoxRadioCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.Code)} context={props.context}/>

                        </div>
         </form>
                </>
        );
    }
    getMobileView(props: SearchBoxToneOptionComponentProps, state: SearchBoxToneOptionComponentState, cssStyle: SearchBoxToneOptionCSSStyle):JSX.Element
    {
        // this.listViewModel.setCssStyle(this.mobileCssStyle);
        return(
            <>
            <form onSubmit={this.onSearchBoxClick}>

                 <div id="search-col-main-wrapper" style={cssStyle.getMobileMainDivCSSStyle()}>
             {/* <div onClick={()=>this.showOption(state)} style={cssStyle.getMobileSearchBoxImageDivCSSStyle()}>
                        <label style={cssStyle.getMobileSearchLabelCSSStyle()}>
                            {state.defaultOption}
                            <img  style={{width:'10px',marginLeft:'12px',height:'6px'}} src={this.getContext().getResources().getImage("downArrow.svg")}/>

                        </label>
                        {         
                            state.isSearchOptionSelected &&
                            <div id="search-col-drop-down" onMouseLeave={()=>this.hideOption(state)} style={cssStyle.getMobileDropDownSSStyle()}>
                                <DropDownListComponent cssStyle={new SearchDropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={props.context}/>
                            </div>
                           
                        }

                 </div> */}
                <input placeholder={props.context.getResources().getString(Strings.type_to_search)} onChange={this.onChange} value={state.searchKey} ref={(item: any) => {this.searchInput = item;}} type="text" id='search' style={cssStyle.getMobileSearchBoxInputDivCSSStyle()}/>
                <img  onClick={this.onSearchBoxClick} style={{marginTop:'14px',marginRight:"15px",marginLeft:'10px',cursor:'pointer'}} src={props.context.getResources().getImage('search.svg')} height="12px" width="12px" />

                
             </div> 
             {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                        <div style={{width:"100%",height:"40px",display:"flex",justifyContent:"center",marginTop:"10px"}}>
                                <CheckboxWithTextComponent onChange={(ischecked, title)=>this.onSelected(ischecked, this.getContext().getResources().getString(Strings.song),this.getContext().getResources().getString(Strings.Song))} isChecked={state.defaultOptionId === props.context.getResources().getString(Strings.song)} style={new MobileSearchBoxRadioCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.Song)} context={props.context}/>
                                <CheckboxWithTextComponent onChange={(ischecked, title)=>this.onSelected(ischecked, this.getContext().getResources().getString(Strings.singer),this.getContext().getResources().getString(Strings.Singer))} isChecked={state.defaultOptionId === props.context.getResources().getString(Strings.singer)} style={new MobileSearchBoxRadioCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.Singer)} context={props.context}/>
                                <CheckboxWithTextComponent onChange={(ischecked, title)=>this.onSelected(ischecked, this.getContext().getResources().getString(Strings.code),this.getContext().getResources().getString(Strings.Code))} isChecked={state.defaultOptionId === props.context.getResources().getString(Strings.code)} style={new MobileSearchBoxRadioCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.Code)} context={props.context}/>
                            </div>
           </form>                 
            </>
        );
    }
    onChange(e: any):void
    {
        if(this.searchInput !== null)
        {
            console.log("onChange() : " + e.target.value);
            (this.getUIComponentHandler() as SearchBoxToneOptionComponentHandler).onChange(e.target.value);
        }
    }

    onSearchBoxClick(e:any):void
    {
        e.preventDefault();           

        if(this.searchInput !== null)
        {
            console.log("onSearchBoxClick() : " + this.searchInput.value);

            (this.getUIComponentHandler() as SearchBoxToneOptionComponentHandler).onSearchBoxButtonClicked(this.searchInput.value);
        }
    }

    onSelected(isSelected: boolean, id:string, title: string)
    {
        console.log("Search option isselected :",isSelected , " id: " , id , " title:" , title);
        (this.getUIComponentHandler() as SearchBoxToneOptionComponentHandler).onTypeChange(isSelected,id,title);
    }
   

    private hideOption(state:SearchBoxToneOptionComponentState)
    {
        (this.getUIComponentHandler() as SearchBoxToneOptionComponentHandler).onDropdownOptionClick(false,state.searchKey);
    }

    private showOption(state:SearchBoxToneOptionComponentState)
    {
        (this.getUIComponentHandler() as SearchBoxToneOptionComponentHandler).onDropdownOptionClick(true,state.searchKey);
   
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptionview.tsx